<template>
    <div class="form-text-object-group">
        <label :for="customId" class="form-text-object-group__label" v-if="label">
            {{ label }}
            <span v-if="required" class="sah-input__label-flag">
                {{ requiredFieldLabelFlag }}
            </span>
        </label>
        <div :id="customId" class="form-text-object-group__entries">
            <div
                v-for="(value, name) in internalValue"
                :key="name"
                class="form-text-object-group__entry"
                v-show="isSupportedLanguage(name)"
            >
                <div class="form-text-object-group__entry-name" :class="`form-text-object-group__language-${name}`">
                    {{ name }}
                </div>
                <component
                    :is="textObjectFormInput"
                    v-model="internalValue[name]"
                    :required="required"
                    class="form-text-object-group__entry-value"
                ></component>
            </div>
        </div>
    </div>
</template>
<script>
import {SahInput, FormSelectGroup, FormTextareaGroup, mixins} from "atom";

const {Proxyable} = mixins;

export default {
    name: "form-text-object-group",
    mixins: [Proxyable],
    props: {
        id: {type: String},
        label: {type: String},
        textObjectType: {type: String, default: "textObject"},
        required: {type: Boolean, default: false},
        requiredFieldLabelFlag: {type: String, default: "*"},
    },
    components: {
        SahInput,
        FormSelectGroup,
        FormTextareaGroup,
    },
    methods: {
        isSupportedLanguage(language) {
            return this.$settings.languages.supported.indexOf(language) !== -1;
        },
    },
    computed: {
        customId: function() {
            return this.id || this._uid;
        },
        textObjectFormInput() {
            return this.textObjectType === "textObject" ? "sah-input" : "form-textarea-group";
        },
        localesSelectOptions() {
            let localesOptions = this.$settings.languages.supported.map(element => ({text: element, value: element}));
            localesOptions.unshift({text: "", value: null, disabled: true});
            return localesOptions;
        },
    },
    data() {
        const textObject = {};
        this.$settings.languages.supported.forEach(language => {
            textObject[language] = this.value?.[language] || "";
        });
        return {
            internalLazyValue: textObject,
            isAdding: false,
            newEntryName: "",
            newEntryValue: "",
        };
    },
    watch: {
        internalValue: {
            handler(value) {
                this.$emit("change", value);
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.form-text-object-group::v-deep {
    @apply mb-2;

    .form-text-object-group__label {
        @apply inline-block font-bold mb-1;
    }

    .form-text-object-group__entry {
        @apply flex w-full justify-between mb-2;
    }

    .form-text-object-group__entry-name {
        @apply mr-2;
    }

    .form-text-object-group__entry-value {
        @apply w-full;
    }

    .form-text-object-group__entry-control {
        @apply w-1/12;
        color: $text-filter-color;
        &:hover {
            @apply cursor-pointer;
            color: $text-filter-hover-color;
        }
    }

    .form-text-object-group__new-entry {
        @apply flex justify-center items-center;
    }

    .form-text-object-group__entry-name_new {
        @apply w-2/12;
    }

    .form-text-object-group__entry-value_new {
        @apply w-9/12;
    }
}
</style>
